import CLIENT_SITE_TYPES from '@/enums/clientSiteTypes';
import getClientCeEntryNavigation from '@/data/Navigation/clientCeEntry';
import getClientNavigation from '@/data/Navigation/client';
import getClientQaNavigation from '@/data/Navigation/clientQa';
import getClientApNavigation from '@/data/Navigation/clientAp';
import getAdminNavigation from '@/data/Navigation/admin';
import getHospitalNavigation from '@/data/Navigation/hospital';
import USER_ROLES from '@/enums/userRoles';

export default function getNavigation(store) {
  let navigation = [];
  if (store.state.siteInfo.role === 'client') {
    if (store.state.siteInfo.clientSiteType === CLIENT_SITE_TYPES.CE_ENTRY) {
      navigation = getClientCeEntryNavigation(store);
    } else if (store.state.user.userTypeId === USER_ROLES.CLIENT_QA_USER) {
      navigation = getClientQaNavigation(store);
    } else if (store.state.user.userTypeId === USER_ROLES.CLIENT_AP_USER) {
      navigation = getClientApNavigation(store);
    } else {
      navigation = getClientNavigation(store);
    }
  } else if (store.state.siteInfo.role === 'admin') {
    navigation = getAdminNavigation(store);
  } else if (store.state.siteInfo.role === 'hospital') {
    navigation = getHospitalNavigation(store);
  }
  return navigation;
}
